import { render, staticRenderFns } from "./BremenLevel.vue?vue&type=template&id=17a1e7f0&scoped=true&"
import script from "./BremenLevel.vue?vue&type=script&lang=js&"
export * from "./BremenLevel.vue?vue&type=script&lang=js&"
import style0 from "./BremenLevel.vue?vue&type=style&index=0&id=17a1e7f0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a1e7f0",
  null
  
)

export default component.exports